import { render, staticRenderFns } from "./SkillsCloud.vue?vue&type=template&id=bc39af50&scoped=true&"
import script from "./SkillsCloud.vue?vue&type=script&lang=js&"
export * from "./SkillsCloud.vue?vue&type=script&lang=js&"
import style0 from "./SkillsCloud.vue?vue&type=style&index=0&id=bc39af50&prod&lang=less&scoped=true&"
import style1 from "./SkillsCloud.vue?vue&type=style&index=1&id=bc39af50&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc39af50",
  null
  
)

export default component.exports